// Error text for the vendor test endpoints (test-connection, live-test). admin-api answers 400
// `{ error, code: 'SAVED_SECRET_HOST_MISMATCH' }` when a test would send the vendor's saved secrets
// to a host outside its saved configuration; the server message names the host, and the hint says
// how to proceed.

export const SAVED_SECRET_HOST_MISMATCH = 'SAVED_SECRET_HOST_MISMATCH';

export const SAVED_SECRET_HOST_MISMATCH_HINT =
  'Saved secrets are only sent to hosts in this vendor’s saved configuration. Re-enter the secret to test a different host, or save the new URL first.';

/** Message for a failed vendor test request (axios error or plain Error). */
export function vendorTestErrorMessage(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: unknown }; message?: unknown } | null;
  const data = e?.response?.data;
  let message = '';
  let code = '';
  if (data && typeof data === 'object') {
    const o = data as Record<string, unknown>;
    if (typeof o.error === 'string') message = o.error.trim();
    if (typeof o.code === 'string') code = o.code;
  }
  if (code === SAVED_SECRET_HOST_MISMATCH) {
    return message ? `${message} ${SAVED_SECRET_HOST_MISMATCH_HINT}` : SAVED_SECRET_HOST_MISMATCH_HINT;
  }
  if (message) return message;
  if (typeof e?.message === 'string' && e.message.trim()) return e.message.trim();
  return fallback;
}

/**
 * Auth note for a live-test result (fe-admin-portal#122). admin-api reports why it could not add
 * auth in `auth.error`, e.g. an env key that Live Test cannot read. Returns null when there is
 * nothing to add: no auth error, or the same text is already the result's main error.
 */
export function liveTestAuthWarning(result: { error?: string; auth?: { error?: string } } | null | undefined): string | null {
  const authError = result?.auth?.error?.trim();
  if (!authError) return null;
  if (result?.error?.trim() === authError) return null;
  return `Auth not added: ${authError}`;
}
